import { Col } from 'antd';
import React, { FC, useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkButton } from 'components/atoms/button';
import { TimeoffDrawer } from './timeoff-drawer';

export type TimeoffDrawerType = 'TIMEOFF_FORM' | 'TIMEOFF_HISTORY' | null;

export const TimeOffSetting: FC = () => {
  const [currentDrawerType, setCurrentDrawerType] =
    useState<TimeoffDrawerType>(null);

  const handleTimeoffClick = useCallback(
    (drawerType: TimeoffDrawerType) => {
      setCurrentDrawerType(drawerType);
    },
    [setCurrentDrawerType],
  );

  const handleClose = useCallback(() => {
    setCurrentDrawerType(null);
  }, [setCurrentDrawerType]);

  return (
    <>
      <Col>
        <LinkButton onClick={() => handleTimeoffClick('TIMEOFF_FORM')}>
          <FormattedMessage id="settings.profile.timeoff.cta.apply_timeoff" />
        </LinkButton>
      </Col>

      <Col>
        <LinkButton onClick={() => handleTimeoffClick('TIMEOFF_HISTORY')}>
          <FormattedMessage id="settings.profile.timeoff.cta.history_view" />
        </LinkButton>
      </Col>

      <TimeoffDrawer handleClose={handleClose} drawerType={currentDrawerType} />
    </>
  );
};
